<template>
  <v-dialog
    v-model="isDialogOpen"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    sentry-tag="m-add-goal-dialog"
    width="unset"
  >
    <v-card class="user-book-container pa-4">
      <div class="d-flex justify-end">
        <a sentry-tag="m-add-goal-dialog-dialog.button.close" @click="$emit('input', false)">
          <v-img contain height="24" src="@/assets/close-icon.svg" width="24" />
        </a>
      </div>
      <v-card-title>
        {{ $t('mentoring.goals.dialogs.add.title') }}
      </v-card-title>
      <v-card-text>
        <m-text-field
          ref="goalField"
          v-model="newGoal.text"
          :disabled="loading"
          autofocus
          @keydown.enter.exact.prevent="createGoal"
        />
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn :loading="loading" @click="createGoal" color="button" depressed>
          {{ $t('mentoring.goals.dialogs.add.create') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { IMentoringSession, ITenant } from '@mentessa/types';
import { mapState } from 'vuex';
import { TenantState } from '@/store/tenant';
import MTextField from '@/components/Inputs/MTextField/MTextField.vue';
import { CreateMentoringSessionGoal } from '@/store/mentoring';

export default Vue.extend({
  name: 'm-add-goal-dialog',
  components: { MTextField },
  props: {
    value: { type: Boolean, default: false },
    mentoringSession: { type: Object as PropType<IMentoringSession> },
  },
  data: () => ({
    loading: false,
    newGoal: {
      text: '',
    },
  }),
  computed: {
    ...mapState<TenantState>('tenant', {
      tenant: (state: TenantState): ITenant => state.tenant,
    }),
    isDialogOpen: {
      get() {
        return this.value;
      },
      set(value: boolean) {
        this.newGoal = { text: '' };
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async createGoal() {
      this.loading = true;
      try {
        await this.$store.dispatch(new CreateMentoringSessionGoal(this.mentoringSession, this.newGoal));
        this.isDialogOpen = false;
      } finally {
        this.loading = false;
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.user-book-container {
  width: 400px;
  //background-color: var(--v-background-base);
  //min-height: 80%;
  //height: 100%;
  //width: 100%;
  //display: flex;
  //flex-direction: column;
  //overflow: auto;
}
</style>
